import React, { PropTypes } from 'react';
import '../../styles/SelectStudent';
import moment from 'moment';

let SelectStudent = React.createClass({
	propTypes: {
		getLastObservationDate: PropTypes.func.isRequired,
		gradeLevel: PropTypes.number,
		label: PropTypes.string.isRequired,
		minimumMinutesSinceLastObservation: PropTypes.number,
		onChange: PropTypes.func.isRequired,
		resetSelection: PropTypes.func.isRequired,
		selectedStudentId: PropTypes.any,
		// `allSelectedStudentIds` are already selected in other SelectStudent components on the
		// parent page, and should not be listed for selection here, in order to prevent the same
		// student from being selected twice
		allSelectedStudentIds: PropTypes.array,
		students: PropTypes.array
	},

	getInitialState: function() {
		return {
			// can be 'above', 'below', or 'none'.  'above' is actually at or above
			gradeLevelRestriction: 'none'
		};
	},

	getStudents: function() {
		let { gradeLevel, students } = this.props,
			{ gradeLevelRestriction } = this.state;

		if (students.asMutable) {
			students = students.asMutable();
		}

		// Don't show students who were selected elsewhere, unless it's the student that
		// is already selected in this component
		let availableStudents = students.filter((student) => {
			return !this.props.allSelectedStudentIds.includes(student.id) || student.id === this.props.selectedStudentId;
		});

		if (gradeLevelRestriction === 'above' || gradeLevelRestriction === 'below') {
			return availableStudents.filter((student) => {
				if (student.lwrge === null) {
					return false;
				}

				if (gradeLevelRestriction === 'above') {
					return student.lwrge >= gradeLevel;
				} else {
					return student.lwrge < gradeLevel;
				}
			});
		} else {
			return availableStudents;
		}
	},

	handleChangeGradeLevelRestriction: function(ev) {
		this.setState({ gradeLevelRestriction: ev.target.value }, () => {
			// If the selection criteria are changed such that the selected student is no longer
			// available for selection, reset the selection
			let isSelectedStudentAvailable = false;
			this.getStudents().every((student) => {
				if (student.id === this.props.selectedStudentId) {
					isSelectedStudentAvailable = true;
					return false;
				} else {
					return true;
				}
			});

			if (!isSelectedStudentAvailable) {
				this.props.resetSelection();
			}
		});
	},

	getStudentsForRandomSelection: function() {
		return this.getStudents().filter((student) => {
			let lastObservationDate = this.props.getLastObservationDate(student.id);

			if (!lastObservationDate) {
				let minutesSinceLastObservation = moment().local().diff(moment(lastObservationDate, 'YYYY-MM-DD h:mma'), 'minutes');
				let hasRecentObservation = minutesSinceLastObservation < this.props.minimumMinutesSinceLastObservation;
				// This is a little whacky, and I always have to think it through.
				// Since we're filtering students for random selection, we want to exclude students with recent
				// observations - in other words, students with recent observations should return false here
				return !hasRecentObservation;
			} else {
				return true;
			}
		});
	},

	selectRandomStudent: function() {
		let students = this.getStudentsForRandomSelection();

		let student = students[Math.floor(Math.random() * students.length)];
		if (student) {
			this.props.onChange(student.id);
		}
	},

	render: function() {
		let students = this.getStudents(),
			randomStudents = this.getStudentsForRandomSelection();

		return(
			<div className="select-student">
				<h4>{ this.props.label }</h4>
				<div className="grade-level-restriction well well-sm">
					<label>Grade level restriction</label>
					<div className="grade-level-controls">
						<div className="radio-inline">
							<label>
								<input
									type="radio"
									value='none'
									onChange={ this.handleChangeGradeLevelRestriction }
									checked={ this.state.gradeLevelRestriction === 'none' }
								/>
									None
							</label>
						</div>
						<div className="radio-inline">
							<label>
								<input
									type="radio"
									value="above"
									onChange={ this.handleChangeGradeLevelRestriction }
									checked={ this.state.gradeLevelRestriction === 'above' }
								/>
									At or above
							</label>
						</div>
						<div className="radio-inline">
							<label>
								<input
									type="radio"
									value="below"
									onChange={ this.handleChangeGradeLevelRestriction }
									checked={ this.state.gradeLevelRestriction === 'below' }
								/>
									Below
							</label>
						</div>
					</div>
				</div>
				{
					students && students.length ? (
						<div className="selection-controls">
							<div className="form-group manual-selection">
								<select
									className="form-control"
									value={ this.props.selectedStudentId ? this.props.selectedStudentId : '' }
									onChange={ (ev) => this.props.onChange(ev.target.value) }
								>
									<option value='' hidden>Select manually...</option>
									{
										students.map((student) => {
											return (
												<option value={ student.id } key={ 'student-' + student.id }>
													{ student.last_name + ', ' + student.first_name  + ' (LWRGE: ' + (student.lwrge === null ? 'n/a' : student.lwrge) + ')' }
												</option>
											);
										})
									}
								</select>
							</div>
							<span className="control-separator">or</span>
							<button
								type="button"
								onClick={ this.selectRandomStudent }
								className="btn btn-default random-selection"
								disabled={ randomStudents.length === 0 }
							>
								Select random student
							</button>
							{
								randomStudents.length > 0 ? '' : (
									<div className="no-random-students">
										No students available for random selection
									</div>
								)
							}
						</div>
					) : (
						<div className="no-students-found">No students found</div>
					)
				}
			</div>
		);
	}
});

module.exports = SelectStudent;



// WEBPACK FOOTER //
// ./frontend/olos/js/components/SelectStudent.jsx